import { create } from "zustand";
import api, { setAffToken } from "./api";

export const useAffAuth = create((set) => ({
  partner: null,
  status: "checking", // 'checking' | 'authed' | 'guest'

  bootstrap: async () => {
    try {
      const { data } = await api.get("/affiliate/me");
      set({ partner: data, status: "authed" });
    } catch {
      set({ partner: null, status: "guest" });
    }
  },

  setPartner: (partner) => set({ partner, status: "authed" }),

  login: async (email, password) => {
    const { data } = await api.post("/affiliate/login", { email, password });
    if (data?.access_token) setAffToken(data.access_token);
    const me = await api.get("/affiliate/me");
    set({ partner: me.data, status: "authed" });
  },

  signup: async (form) => {
    const { data } = await api.post("/affiliate/signup", form);
    if (data?.access_token) setAffToken(data.access_token);
    const me = await api.get("/affiliate/me");
    set({ partner: me.data, status: "authed" });
  },

  logout: async () => {
    try {
      await api.post("/affiliate/logout");
    } catch {
      // ignore
    }
    setAffToken(null);
    set({ partner: null, status: "guest" });
  },

  refresh: async () => {
    const { data } = await api.get("/affiliate/me");
    set({ partner: data, status: "authed" });
  },
}));
